// extracted by mini-css-extract-plugin
module.exports = {"root":"ads-aside-module--root--2h5-M","image":"ads-aside-module--image--319Uq"};